import { FC } from 'react';

import styles from './RightColumnIsPublic.module.scss';

type Props = {
  isPublic: boolean;
};

const RightColumnIsPublic: FC<Props> = ({ isPublic }) => {
  return (
    <>
      <div className={styles.right_column_container_item}>
        <div className={styles.right_column_container_is_public_area}>
          <p className={styles.right_column_container_is_public_area_title}>公開設定</p>
        </div>
        <div className={styles.right_column_container_is_public_wrapper}>{isPublic ? '公開' : '非公開'}</div>
      </div>
    </>
  );
};

export default RightColumnIsPublic;
